import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { CognitiveResults } from '@app/interface/cognitiveResults.model';
import { Observable, of } from 'rxjs';
import { mergeMap, switchMap, take } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { FirebaseAuthService } from './firebaseauth.service';
import { StudiesService } from './studies.service';

@Injectable({
  providedIn: 'root',
})
export class CognitiveResultsService {
  readonly EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  readonly EXCEL_EXTENSION = '.xlsx';

  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {
    this.getUserByStudyId();
  }

  public exportAsExcelFile(table: HTMLElement, excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, excelFileName);
    XLSX.writeFile(wb, excelFileName + this.EXCEL_EXTENSION);
  }

  public getCognitiveByCognitiveStudyId(cognitiveId: string, studyId: string): Observable<any> {
    return this.afAuth.authState.pipe(
      mergeMap((user: firebase.default.User) => {
        if (user) {
          return this.store
            .collection<CognitiveResults>('cognitive-results', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('cognitiveId', '==', cognitiveId);
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }

  public getCognitivesAndResultsByStudyId(userId?: string): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection('cognitive-results', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('userId', '==', userId);
            })
            .valueChanges();
        } else {
          return of([]);
        }
      }),
      take(1)
    );
  }

  public getUserByStudyId(): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection('cognitive-results', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId);
            })
            .valueChanges();
        } else {
          return of([]);
        }
      }),
      take(1)
    );
  }
}
